import { useMemo } from "react";
import { useTheme } from "@fluentui/react/lib/Theme";
import { mergeStyleSets } from "@fluentui/react/lib/Styling";

import { flex, flexItem, flexItemGrow } from "Utils/Styles";

const classNames = {
  root: `ListNotExportableDialogRoot`,
  description: `ListNotExportableDialogDescription`,
  separator: `ListNotExportableDialogSeparator`,
  list: `ListNotExportableDialogList`
};

export function useListNotExportableStyles() {
  const { spacing } = useTheme();
  return useMemo(
    () => mergeStyleSets({
      root: [
        classNames.root,
        {
          ...flex,
          height: `100%`,
          overflow: `hidden`
        }
      ],
      description: [
        classNames.description,
        {
          ...flexItem,
          marginTop: spacing.m
        }
      ],
      separator: [classNames.separator, { ...flexItem }],
      list: [
        classNames.list,
        {
          ...flexItem,
          ...flexItemGrow,
          overflow: `hidden scroll`,
          paddingRight: spacing.m
        }
      ]
    }),
    [spacing]
  );
}
